import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, Rating } from '@mui/material';
import {
	ModeStandby,
	Favorite,
	FavoriteBorder,
	Shield,
	ShieldOutlined,
	Bloodtype,
	BloodtypeOutlined,
	Psychology,
	PsychologyOutlined,
	CircleOutlined,
	CheckBoxOutlineBlank,
	CheckBoxOutlined,
} from '@mui/icons-material';

const useStyles = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		margin: '0 10%',
	},
	titleTop: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start',
	},
});

const CounterWidget = (props) => {
	const classes = useStyles();
	const { id, value, readonly, disabled, onChange, options, schema, uiSchema } = props;
	console.log('cotuner widget props', props);

	const { iconType = 'Default', fillColor, emptyColor, titlePosition } = uiSchema || {};
	const { minimum, maximum } = schema || {};

	const iconMap = {
		Default: [ModeStandby, CircleOutlined, 'black', 'black'],
		Radio: [ModeStandby, CircleOutlined, 'black', 'black'],
		Health: [Favorite, FavoriteBorder, '#FF4136', '#E6E6E6'],
		Defense: [Shield, ShieldOutlined, 'blue', 'black'],
		Blood: [Bloodtype, BloodtypeOutlined, '#FF4136', '#E6E6E6'],
		Mental: [Psychology, PsychologyOutlined, 'blue', 'black'],
		Checkbox: [CheckBoxOutlined, CheckBoxOutlineBlank, 'black', 'black'],
	};

	const onRatingChange = (event, newValue) => {
		if (!readonly && !disabled) {
			onChange(newValue);
		}
	};

	const [fillIcon, emptyIcon, iconFillColor, iconEmptyColor] = iconMap[iconType];

	const iconProps = {
		style: { color: fillColor || iconFillColor },
	};
	const emptyIconProps = {
		style: { color: emptyColor || iconEmptyColor },
	};

	return (
		<div className={titlePosition === 'top' ? classes.titleTop : classes.root}>
			<Typography variant="body1" style={{ marginRight: '1rem' }}>
				{schema?.title}
			</Typography>
			<Rating
				name={id}
				value={value}
				onChange={onRatingChange}
				disabled={readonly || disabled}
				icon={React.createElement(fillIcon, iconProps)}
				emptyIcon={React.createElement(emptyIcon, emptyIconProps)}
				max={maximum}
			/>
		</div>
	);
};

export default CounterWidget;
